export const YEARLY_DUE_DATE = "hoaYearlyDueDate";
export const MONTHLY_DUE_DATE = "hoaMonthlyDueDate";
export const LEASE_DUE_DATE = "hoaLeaseAdminDueDate";
export const CURRENCY = "currency";
export const BANK_NAME = "bankName";
export const ROUTING_NUMBER = "bankRoutingNumber";
export const ACCOUNT_NUMBER = "bankAccountNumber";
export const PHONE_1 = "zellePhone1";
export const PHONE_2 = "zellePhone2";
